import React from 'react'

import Text from '../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import NumberInput from './NumberInput'
import Slider from './Slider'

const SliderInput = ({ value, onChange, ...props }) => {
  return (
    <Grid align="center" gap={1}>
      <Col flex={1}>
        <Slider value={value} onChange={onChange} {...props} />
      </Col>
      <Col width="25%">
        <NumberInput value={value} onChange={onChange} step="0.1" />
      </Col>
    </Grid>
  )
}

export default SliderInput
